<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

       <CardUpdatableHeader :row="row" :level="level"/>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="row.shc_code" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._code')" persistent-hint>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="row.shc_name" :disabled="level.dialogValues.form_disabled" :label="$t('texts._name')" :hint="$t('hints._name')"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="row.shc_desc"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts._desc')"
                  :hint="$t('hints._desc')"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
               <v-col cols="12">
                 <ddoSelectPlatform :callbacks="PLFcallbacks" ref="mySelect" :options="PLFoptions"/>
               </v-col>
            </v-row>

            <v-row>
               <v-col cols="6" style="max-height: 300px" class="overflow-y-auto">
                <h4>{{ $t('subtitles.shc_macros') }}</h4>
                <draggable
                  class="list-group"
                  tag="ul"
                  v-bind="dragOptions" 
                  v-model="filteredList"
                  draggable=".li-items"
                >
                    <li class="list-group-item li-items" v-for="(element,index) in filteredList" :key="element.xxx_key">

                      <b-card class="bg-secondary" no-body>
                        <div slot="header">
                          <b-badge class="m-1" variant="warning">{{ element.xxx_type }}</b-badge>
                          {{element.xxx_code}}
                          <div class="card-header-actions">
                            <v-btn icon @click="show=!show">
                              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <b-card-body v-if="show">
                          {{ element.xxx_name }}
                        </b-card-body>
                      </b-card>
<!--
                      <v-card class="bg-secondary">
                        <v-card-subtitle>
                          <v-btn icon @click="show=!show">
                            <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          </v-btn>
                          <b-badge class="m-1" variant="warning">{{ element.xxx_type }}</b-badge>
                          {{element.xxx_code}}
                        </v-card-subtitle>
                        <v-card-text v-show="show">
                          {{ element.xxx_name }}
                        </v-card-text>
                      </v-card>
-->
                    </li>
                  <div slot="header">
                    <v-switch v-model="level.dialogValues.samePLF" :disabled="row.plf_pk==null" label="Same Platform"/>
                  </div>

                </draggable>
              </v-col>

               <v-col cols="6">
                <h4>{{ $t('subtitles.shc_steps') }}</h4>
                <draggable
                  class="list-group"
                  tag="ul"
                  v-bind="dragOptions" 
                  v-model="row.shc_steps"
                >
                  <transition-group type="transition">
                    <li class="list-group-item" v-for="(element,index) in row.shc_steps" :key="element.xxx_key">

                      <b-card class="bg-primary" no-body>
                        <div slot="header">
                          <b-badge class="m-1" variant="info">{{ index+1 }}</b-badge>
                          <b-badge class="m-1" variant="warning">{{ element.xxx_type }}</b-badge>
                          {{element.xxx_code}}
                          <div class="card-header-actions">
                            <c-switch v-model="element.xxx_skippable" size="sm" color="warning" label dataOn="Opt." dataOff="Req."/>
                            <v-btn icon @click="show=!show">
                              <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <b-card-body v-if="show">
                          {{ element.xxx_name }}
                        </b-card-body>
                      </b-card>
<!--
                      <v-card dense class="bg-primary">
                        <v-card-subtitle>
                          <b-badge class="m-1" variant="info">{{ index+1 }}</b-badge>
                          <v-btn icon @click="show=!show">
                            <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          </v-btn>
                          <b-badge class="m-1" variant="warning">{{ element.xxx_type }}</b-badge>
                          {{element.xxx_code}}
                          <c-switch :checked="element.xxx_skippable" size="sm" color="warning" label dataOn="Opt." dataOff="Req."/>
                        </v-card-subtitle>
                        <v-card-text v-show="show">
                          {{ element.xxx_name }}
                        </v-card-text>
                      </v-card>
-->
                    </li>
                  </transition-group>
                </draggable>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-if="!level.dialogValues.form_create" cols="12">
                <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.shc_create,'long') }}<br/>
                <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.shc_create,'long') }}
              </v-col>
            </v-row>
         </v-container>
          <small>*{{ $t('texts.requiredfield') }}</small>
        </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect from '@/components/ddoSelect.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue';
import draggable from 'vuedraggable';
import { Switch as cSwitch } from '@coreui/vue'

export default {
    name: 'CardUpdatableShortcode',
    extends: CardUpdatable,
    components: {
        ddoAlert,
        ddoSelect,
        ddoSelectPlatform,
        draggable,
        CardUpdatableHeader,
        CardUpdatableFooter,
        cSwitch,
    },

    props: {
    },

    data: function () {
      return {
        PLFcallbacks: {},
        PLFoptions: {
          initial: null,
          required: true,
          disabled: false,
          multiple: false,
          clearable: false,
          item_text: "plf_name",
          item_value: "plf_pk",
          item_disabled: "",
          hide_selected: true,
          label: i18n.t('texts.platform'),
        },
        show: false,
        MAC_available_list: [],
      }
    },

    computed: {
      filteredList: {
        get: function() {
          return this.MAC_available_list.filter(item => (this.level.dialogValues.samePLF==false || item.plf_pk==this.level.row.plf_pk));
        },
        set: function(value) {
          /*
           * If on same Platform, we first remove all items from MAC_available_list having platform of current shortcode,
           *   and them, merge MAC_available_list with value, which is an array of current items. By doing this, we do not
           *   touch the items of other platform.
           * If not on same Platform, it is simplier : just affect the array value to MAC_available_list
          */ 
          if ( this.level.dialogValues.samePLF==true ) {
            for (var i=0;i<this.MAC_available_list.length;i++ ) {
              if ( this.MAC_available_list[i].plf_pk==this.level.row.plf_pk) {
                this.MAC_available_list.splice(i,1);
                i--;
              } // if
            } // for
            this.MAC_available_list = this.MAC_available_list.concat(value);
          } else {
            this.MAC_available_list = value;
          }
        }
      },
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          ghostClass: "ghost"
        };
      },
    },

    async created() {
      console.log('CardUpdatableShortCode::created');
      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change = this.change;
    },

    async mounted() {
      console.log('CardUpdatableShortCode::mounted');
      /*
       * We clone 'this.level.dialogValues.macros' to 'this.MAC_available_list'
      */
      this.MAC_available_list = JSON.parse(JSON.stringify(this.level.dialogValues.macros));
    },

    methods: {

      async refresh_select_plf(key=null) {
         await this.$refs.mySelect.refresh_rows(key);
      },

      clear_macros_list() {
        this.level.row.shc_steps.forEach( (element,index) => {
          for (var i=0;i<this.MAC_available_list.length;i++ ) {
            if ( this.MAC_available_list[i].xxx_key==element.xxx_key) {
              this.MAC_available_list.splice(i,1);
              break;
            } // if
          } // for
        });
      },

      async build_steps_list(row) {
        console.log('build_steps_list');

        this.level.row.shc_steps = [];
        this.loading = true;
        var { errorinfos, api_response } = await this.$api.getRows(this.$router,'shortcode'+'/'+row._pk+'/steps');
        this.loading = false;
        if ( api_response.error==0 && api_response.rows ) {
          this.level.row.shc_steps = api_response.rows;
        }

        if ( this.level.dialogValues.macros ) {
          this.MAC_available_list = JSON.parse(JSON.stringify(this.level.dialogValues.macros));
        }
        this.clear_macros_list();
      },

      async build_select_plf(key=null) {
         console.log('CardUpdatableShortCode::build_select_plf, SPECIFIC/ShortCode');
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'platform');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change(value,item=null) {
         console.log('CardUpdatableShortCode::change, SPECIFIC/ShortCode, value='+value);
         if ( value!=null) {
            this.level.row.plf_pk = value;
         } else {
           this.level.row.plf_pk = null;
         }
      },
      
    },
}
</script>

<style scoped>
.list-group-item {
  cursor: move;
}
</style>